export * from "./BannerWin";
export { default } from "./BannerWin";
